/** 展示层 headline 双色拆分 — fe-spec §1.5 */
export function splitFitnessHeadline(headline: string): {
  accentPart: string;
  restPart: string;
} {
  const trimmed = headline.trim();
  if (!trimmed) {
    return { accentPart: "", restPart: "" };
  }

  const tokens = trimmed.split(/\s+/);
  if (tokens.length === 1) {
    return { accentPart: tokens[0] ?? "", restPart: "" };
  }

  const accentPart = tokens.slice(0, 2).join(" ");
  const restTokens = tokens.slice(2);
  const restPart = restTokens.length > 0 ? ` ${restTokens.join(" ")}` : "";

  return { accentPart, restPart };
}
